var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

featured();
darkPage();
footerGroup();
categoryNav();
formatLinkIcons();
initNavigation();
setAccentColorVariables();
headerScrollBehavior();

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setupFootnotes();
        // logoMarquee();
        introHighlight();
        fitFooterSiteTitle();
        setupSmoothScroll();
        setupScrollToTop();
        handleVideoPlayback();
        initCarousel3D();
        categoryGridNav();
        initTOCCollisionDetection();

    });
} else {
    setupFootnotes();
    // logoMarquee();
    introHighlight();
    fitFooterSiteTitle();
    setupSmoothScroll();
    setupScrollToTop();
    handleVideoPlayback();
    initCarousel3D();
    categoryGridNav();
    initTOCCollisionDetection();

}

window.addEventListener('scroll', introHighlight);
window.addEventListener('resize', fitFooterSiteTitle);

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function featured() {
    'use strict';
    var feed = document.querySelector('.tag-hash-section-testimonials .single-content');
    if (!feed) return;

    tns({
        container: feed,
        controlsPosition: 'bottom',
        controlsText: [
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        gutter: 16,
        loop: false,
        nav: false,
        mouseDrag: true,
        autoplay: false,
        autoplayButtonOutput: false,
        autoplayHoverPause: false,
        autoplayTimeout: 5000,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 3,
            },
            992: {
                items: 3,
            },
        },
    });
}

function setAccentColorVariables() {
    // Get accent color from HTML attribute
    const accentColor = document.documentElement.getAttribute('data-color-accent');
    if (!accentColor) return;

    // Convert hex to RGB
    const hex = accentColor.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16) / 255;
    const g = parseInt(hex.substring(2, 4), 16) / 255;
    const b = parseInt(hex.substring(4, 6), 16) / 255;

    // Convert RGB to HSL
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // achromatic
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    // Convert to degrees and percentages
    const hDeg = Math.round(h * 360);
    const sPct = Math.round(s * 100);
    const lPct = Math.round(l * 100);

    // Set CSS variables
    document.documentElement.style.setProperty('--accent-base-h', hDeg);
    document.documentElement.style.setProperty('--accent-base-s', `${sPct}%`);
    document.documentElement.style.setProperty('--accent-base-l', `${lPct}%`);

    // Calculate contrast using YIQ
    const rgbR = parseInt(hex.substring(0, 2), 16);
    const rgbG = parseInt(hex.substring(2, 4), 16);
    const rgbB = parseInt(hex.substring(4, 6), 16);
    const yiq = ((rgbR * 299) + (rgbG * 587) + (rgbB * 114)) / 1000;
    
    // Add contrast class to root element
    document.documentElement.classList.remove('accent-text-black', 'accent-text-white');
    document.documentElement.classList.add(yiq >= 128 ? 'accent-text-black' : 'accent-text-white');
}

function initCarousel3D() {
    'use strict';

    // Initialize all carousels on the page
    const carousels = document.querySelectorAll('.carousel-3d');
    if (!carousels.length) return;

    carousels.forEach(carousel => {
        // Check if already initialized
        if (carousel.dataset.carouselInitialized) return;

        // Skip if parent nav-overlay is hidden
        const navOverlay = carousel.closest('.nav-overlay');
        if (navOverlay && !navOverlay.classList.contains('active')) {
            return; // Skip initialization
        }

        const cards = carousel.querySelectorAll('.carousel-card');
        if (cards.length === 0) return;

        // Create carousel instance
        const carouselInstance = new Carousel3D(carousel);

        // Mark as initialized
        carousel.dataset.carouselInitialized = 'true';
    });
}

function darkPage() {
    var isDark = body.classList.contains('tag-hash-dark') ? 'dark' : 'light';
    html.classList.add(`${isDark}-page`);
}

function footerGroup() {
    const footerNav = document.querySelector(".footer-nav");
    if (!footerNav) return;

    const items = document.querySelectorAll(".footer-nav .nav li");
    
    if (!footerNav || !items.length) return;
    
    const groups = [];
    let index = null;

    // Process all items first
    items.forEach(item => {
        const text = item.textContent.trim();
        const PREFIXFOOTERHEADER = "#";
        if (text.includes(PREFIXFOOTERHEADER)) {
            index = index === null ? 0 : ++index;
            groups[index] = { header: "", items: [] };
            groups[index].header = text.slice(PREFIXFOOTERHEADER.length);
        } else if (index !== null) {
            const link = item.querySelector('a');
            if (link) {
                groups[index].items.push({ text, link: link.href });
            }
        }
    });

    // Only proceed if we found groups
    if (groups.length === 0) return;

    // Find the social-links element to move it last
    const socialLinks = footerNav.querySelector('.social-links');

    // Create the new structure
    groups.forEach((group) => {
        const div = document.createElement('div');
        div.classList.add("footer-nav-group");
        const h6 = document.createElement('h6');
        h6.classList.add("footer-group-header");
        h6.innerHTML = group.header;
        const ul = document.createElement("ul");
        ul.classList.add("nav");
        group.items.forEach((item) => {
            const li = document.createElement("li");
            li.innerHTML = `<a href="${item.link}">${item.text}</a>`;
            ul.append(li);
        });
        div.append(h6, ul);
        footerNav.appendChild(div);
    });

    // Move social-links to the end if it exists
    if (socialLinks && socialLinks.parentNode) {
        footerNav.appendChild(socialLinks);
    }

    // Remove the old nav if we have new content
    if (groups.length > 0) {
        const oldNav = document.querySelector(".footer-nav ul.nav");
        if (oldNav && oldNav.parentNode) {  // Check if element exists and has a parent
            oldNav.remove();
        }
    }
}

function setupFootnotes() {
    'use strict';
    const contentSelector = 'article.ghost-content';
    const contentElement = document.querySelector(contentSelector);
    if (!contentElement) return;

    let htmlContent = contentElement.innerHTML;
    const regexPattern = /\[\^(.*?)\]/g;
    
    // Check if there are any footnotes before proceeding
    const matches = htmlContent.match(regexPattern);
    if (!matches) return;

    const footnoteList = document.createElement('ol');
    footnoteList.classList.add('footnote-list');
    footnoteList.id = 'footnotes';
    
    const footnoteWrapper = document.createElement('div');
    footnoteWrapper.classList.add('kg-canvas', 'section-footnotes');
    
    let index = 1;
    
    htmlContent = htmlContent.replace(regexPattern, (match, p1) => {
        footnoteList.innerHTML = footnoteList.innerHTML + `<li id="footnote-${index}">${p1}</li>`;
        const returnValue = `<sup class="footnote"><a href="#footnote-${index}">[${index}]</a></sup>`;
        index++;
        return returnValue;
    });

    contentElement.innerHTML = htmlContent;
    
    footnoteWrapper.appendChild(footnoteList);
    contentElement.appendChild(footnoteWrapper);
}


function introHighlight() {
    const textIntro = document.querySelector('.hero-intro.tag-hash-intro-animate');
    if (!textIntro) return;

    // Select paragraphs and headings (h1, h2, h3, h4, h5, h6)
    const paragraphs = textIntro.querySelectorAll('p');
    const headings = textIntro.querySelectorAll('h1, h2, h3, h4, h5');
    
    // Use querySelectorAll for all target elements directly
    const elements = textIntro.querySelectorAll('p, h1, h2, h3, h4, h5');
    const viewportHeight = window.innerHeight;

    // Function to split text into sentences and sentence fragments (by periods, question marks, exclamation marks, and commas)
    function splitIntoSentences(text) {
        // First split by periods, question marks, and exclamation marks
        const mainSentences = text.match(/[^\.!\?]+[\.!\?]+/g) || [text];
        
        // Then further split each sentence by commas
        const fragments = [];
        mainSentences.forEach(sentence => {
            // Check if the sentence has any commas
            if (sentence.includes(',')) {
                // Split by comma and preserve the comma at the end of each fragment
                const commaFragments = sentence.split(',').map((fragment, index, array) => {
                    // For all but the last fragment, add the comma back
                    return index < array.length - 1 ? fragment + ',' : fragment;
                });
                fragments.push(...commaFragments);
            } else {
                // If no commas, keep the sentence as is
                fragments.push(sentence);
            }
        });
        
        // Return the combined fragments, filtering out any empty ones
        return fragments.filter(fragment => fragment.trim().length > 0);
    }

    // Process each element only once
    if (!textIntro.dataset.processed) {
        elements.forEach(element => {
            // Skip empty elements or those without text content
            if (!element.innerText.trim()) return;
            
            const sentences = splitIntoSentences(element.innerText);
            element.innerHTML = ''; // Clear the element content

            sentences.forEach(sentence => {
                const span = document.createElement('span');
                span.className = 'sentence';
                // Add additional class to identify if it's from a heading
                if (element.tagName.toLowerCase().match(/^h[1-6]$/)) {
                    span.classList.add('heading-sentence');
                }
                span.innerText = sentence.trim() + ' ';
                element.appendChild(span);
            });
        });
        
        // When first processed, only highlight the first sentence
        const firstSentence = textIntro.querySelector('.sentence');
        if (firstSentence) {
            firstSentence.classList.add('intro-highlight');
        }
        
        textIntro.dataset.processed = 'true';
    }

    const allSentences = textIntro.querySelectorAll('.sentence');
    
    // Use fixed values instead of calculating based on viewport height
    const middleOfViewport = 400; // Fixed value in pixels
    
    // Use a fixed value for the trigger point
    const triggerPoint = 320;

    let lastHighlightedIndex = -1;

    // Check if the intro has entered the fixed trigger point
    const introRect = textIntro.getBoundingClientRect();
    const introHasEntered = introRect.top < triggerPoint;

    // Apply highlighting without blurring
    allSentences.forEach((sentence, index) => {
        const rect = sentence.getBoundingClientRect();
        if (introHasEntered && rect.top < middleOfViewport) {
            sentence.classList.add('intro-highlight');
            lastHighlightedIndex = index;
        } else {
            // Only remove highlight if it's not the first sentence
            if (index !== 0) {
                sentence.classList.remove('intro-highlight');
            }
        }
    });

    // Check if we've scrolled past the text intro
    if (introRect.bottom < 0) {
        // If we've scrolled past, highlight all sentences
        allSentences.forEach(sentence => {
            sentence.classList.add('intro-highlight');
        });
    }
}

function logoMarquee() {
    'use strict';
    const marqueeContainer = document.getElementById('logo-marquee');
    if (!marqueeContainer) return;
    
    const logoContainer = marqueeContainer.querySelector('.logo-list-container');
    if (!logoContainer) return;
    
    // Clone logos to create a seamless loop
    const originalLogos = logoContainer.innerHTML;
    logoContainer.innerHTML = originalLogos + originalLogos + originalLogos;
    
    const logoItems = logoContainer.querySelectorAll('.kg-image-card');
    if (!logoItems.length) return;
    
    // Calculate total width of one set of logos
    let singleSetWidth = 0;
    const logoCount = logoItems.length / 3;
    
    for (let i = 0; i < logoCount; i++) {
        const style = window.getComputedStyle(logoItems[i]);
        const width = parseFloat(style.width);
        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;
        singleSetWidth += width + marginLeft + marginRight;
    }
    
    // Set initial position
    let currentPosition = 0;
    let animationId;
    let isPaused = false;
    let speed = window.innerWidth > 768 ? 1 : 0.5; // pixels per frame, slower on mobile
    
    // Make sure container is wide enough and positioned correctly
    logoContainer.style.width = (singleSetWidth * 3) + 'px';
    
    // Animation function with smoother reset logic
    function animate() {
        if (!isPaused) {
            currentPosition -= speed;
            
            // Reset position for seamless loop when first set is off-screen
            if (Math.abs(currentPosition) >= singleSetWidth) {
                // Reset by exactly one set width for seamless transition
                currentPosition = currentPosition + singleSetWidth;
            }
            
            logoContainer.style.transform = `translateX(${currentPosition}px)`;
        }
        animationId = requestAnimationFrame(animate);
    }
    
    // Start animation with a slight delay to ensure proper initialization
    setTimeout(() => {
        animationId = requestAnimationFrame(animate);
    }, 100);
    
    // Pause on hover
    marqueeContainer.addEventListener('mouseenter', () => {
        isPaused = true;
    });
    
    marqueeContainer.addEventListener('mouseleave', () => {
        isPaused = false;
    });
    
    // Adjust speed on window resize
    window.addEventListener('resize', () => {
        speed = window.innerWidth > 768 ? 0.4 : 0.2;
    });
    
    // Clean up on page leave
    window.addEventListener('beforeunload', () => {
        cancelAnimationFrame(animationId);
    });
}

function categoryNav() {
    var currentPageURL = window.location.pathname;

    // Get all <a> tags inside the .blog-navbar div
    var navbarLinks = document.querySelectorAll('.blog-navbar a');

    // Loop through each <a> tag
    navbarLinks.forEach(function(link) {
        // Check if the href attribute matches the current page URL
        if (link.getAttribute('href') === currentPageURL) {
            // Add the is-active class
            link.classList.add('is-active');
        }
    });
}

function categoryGridNav() {
    'use strict';

    const categoryGrid = document.querySelector('.category-grid');
    if (!categoryGrid) return;

    const categoryItems = categoryGrid.querySelectorAll('.category-grid-item');
    if (!categoryItems.length) return;

    // Track the currently expanded item
    let currentExpandedItem = categoryItems[0]; // First item by default

    categoryItems.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
            // Remove expanded class from all items
            categoryItems.forEach(function(i) {
                i.classList.remove('is-expanded');
            });

            // Add expanded class to hovered item
            item.classList.add('is-expanded');

            // Update current expanded item
            currentExpandedItem = item;
        });
    });

    // When mouse leaves the grid, keep the last hovered item expanded
    categoryGrid.addEventListener('mouseleave', function() {
        // Ensure the last hovered item stays expanded
        if (currentExpandedItem) {
            categoryItems.forEach(function(i) {
                i.classList.remove('is-expanded');
            });
            currentExpandedItem.classList.add('is-expanded');
        }
    });

    // Initialize first item as expanded
    if (currentExpandedItem) {
        currentExpandedItem.classList.add('is-expanded');
    }
}

// Shared navigation highlight animation
function setupNavHighlight({navSelector, highlightSelector, itemSelector, activeClass = 'is-active', onNavLeave = null}) {
    var navbar = document.querySelector(navSelector);
    if (!navbar) return;
    var highlight = navbar.querySelector(highlightSelector);
    var items = navbar.querySelectorAll(itemSelector);
    if (!highlight || !items.length) return;

    function moveHighlightTo(element) {
        var rect = element.getBoundingClientRect();
        var navbarRect = navbar.getBoundingClientRect();
        highlight.style.left = (rect.left - navbarRect.left + navbar.scrollLeft) + 'px';
        highlight.style.width = rect.width + 'px';
    }

    // Set highlight to active item on load without transition
    var activeItem = navbar.querySelector(itemSelector + '.' + activeClass);
    if (activeItem) {
        highlight.style.transition = 'none'; // Disable transition
        moveHighlightTo(activeItem); // Position highlight without animation
        
        // Force reflow and restore transition after a small delay
        setTimeout(function() {
            highlight.style.transition = '';
        }, 50); // Small delay to ensure correct positioning
    }

    items.forEach(function(item) {
        item.addEventListener('mouseenter', function() { 
            // Don't move highlight if dropdown is open or if item is inside dropdown
            if (document.body.classList.contains('is-dropdown-open') || item.closest('.gh-dropdown')) {
                return;
            }
            moveHighlightTo(item); 
        });
        item.addEventListener('focus', function() { 
            // Don't move highlight if dropdown is open or if item is inside dropdown
            if (document.body.classList.contains('is-dropdown-open') || item.closest('.gh-dropdown')) {
                return;
            }
            moveHighlightTo(item); 
        });
        item.addEventListener('mouseleave', function() {
            // Don't move highlight if dropdown is open
            if (document.body.classList.contains('is-dropdown-open')) {
                return;
            }
            if (activeItem) moveHighlightTo(activeItem);
        });
        item.addEventListener('blur', function() {
            // Don't move highlight if dropdown is open
            if (document.body.classList.contains('is-dropdown-open')) {
                return;
            }
            if (activeItem) moveHighlightTo(activeItem);
        });
        item.addEventListener('click', function(e) {
            // Prevent transition if clicking the active item
            if (item === activeItem) {
                var prevTransition = highlight.style.transition;
                highlight.style.transition = 'none';
                moveHighlightTo(item);
                void highlight.offsetWidth; // force reflow
                highlight.style.transition = prevTransition;
            }
        });
    });

    // Reposition highlight on window resize
    window.addEventListener('resize', function() {
        if (activeItem) moveHighlightTo(activeItem);
    });
    // Reposition highlight on navbar scroll (for horizontal scroll)
    navbar.addEventListener('scroll', function() {
        if (activeItem) moveHighlightTo(activeItem);
    });

    // Hide highlight on nav mouseleave if requested
    if (onNavLeave === 'hide') {
        navbar.addEventListener('mouseleave', function() {
            highlight.style.opacity = '0';
            highlight.style.pointerEvents = 'none';
        });
        navbar.addEventListener('mouseenter', function() {
            highlight.style.opacity = '1';
            highlight.style.pointerEvents = 'auto';
            if (activeItem) moveHighlightTo(activeItem);
        });

        // Hide highlight when dropdown is open
        const body = document.body;
        const observer = new MutationObserver(() => {
            if (body.classList.contains('is-dropdown-open')) {
                highlight.style.opacity = '0';
                highlight.style.pointerEvents = 'none';
            }
        });
        observer.observe(body, { attributes: true, attributeFilter: ['class'] });
    }
}

function fitFooterSiteTitle() {
    const siteTitleFooter = document.getElementById('site-title-footer');
    if (!siteTitleFooter) return;
    
    const container = siteTitleFooter.parentElement;
    if (!container) return;
    
    // Store original text if not already stored
    if (!siteTitleFooter.getAttribute('data-original-text')) {
        siteTitleFooter.setAttribute('data-original-text', siteTitleFooter.textContent.trim());
    }
    
    const originalText = siteTitleFooter.getAttribute('data-original-text');
    
    // Reset text content
    siteTitleFooter.textContent = originalText;
    
    // Get container width - use offsetWidth for more accurate measurement
    const containerWidth = container.offsetWidth;
    const textLength = originalText.length;
    
    // Calculate font size based on container width and text length
    // The longer the text, the smaller the font; the shorter, the larger
    let fontSize;
    
    if (textLength <= 5) {
        // Very short text - make it very large (like "Ghost" in screenshot)
        fontSize = containerWidth * 0.25; // 25% of container width
    } else if (textLength <= 10) {
        // Short text - make it large
        fontSize = containerWidth * 0.20; // 20% of container width
    } else if (textLength <= 15) {
        // Medium text - make it medium-sized
        fontSize = containerWidth * 0.15; // 15% of container width
    } else if (textLength <= 25) {
        // Longer text - make it smaller
        fontSize = containerWidth * 0.10; // 10% of container width
    } else {
        // Very long text - make it even smaller
        fontSize = containerWidth * 0.08; // 8% of container width
    }
    
    // Apply size limits
    const minFontSize = 24;
    const maxFontSize = Math.min(containerWidth * 0.25, 120); // Cap at 120px or 25% of width
    
    fontSize = Math.max(minFontSize, Math.min(maxFontSize, fontSize));
    
    // Apply the font size
    siteTitleFooter.style.fontSize = `${fontSize}px`;
    
    // Create a temporary span to measure if the result fits
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.whiteSpace = 'nowrap';
    tempSpan.style.fontFamily = window.getComputedStyle(siteTitleFooter).fontFamily;
    tempSpan.style.fontWeight = window.getComputedStyle(siteTitleFooter).fontWeight;
    tempSpan.style.fontSize = `${fontSize}px`;
    tempSpan.textContent = originalText;
    document.body.appendChild(tempSpan);
    
    // Check if text is too wide and adjust if needed
    if (tempSpan.offsetWidth > containerWidth * 0.98) {
        const adjustmentRatio = containerWidth * 0.98 / tempSpan.offsetWidth;
        fontSize = Math.floor(fontSize * adjustmentRatio);
        siteTitleFooter.style.fontSize = `${fontSize}px`;
    }
    
    // Clean up
    document.body.removeChild(tempSpan);
}

function formatLinkIcons() {
    'use strict';
    
    const buttons = document.querySelectorAll('a.kg-btn, a.kg-product-card-button, a.kg-header-card-button, a.button-header, a.button-hero, a.footer-link');
    const currentDomain = window.location.hostname;

    buttons.forEach(button => {
        const url = new URL(button.href);
        const isExternal = url.hostname !== currentDomain;
        const isHeaderCardButton = button.classList.contains('kg-header-card-button');
        
        let iconSvg;
        if (isHeaderCardButton) {
            iconSvg = `<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                            <path d="M5.333 14.667v2.667h16L14 24.667l1.893 1.893L26.453 16 15.893 5.44 14 7.333l7.333 7.333h-16z"></path>
                        </svg>`;
        } else {
            iconSvg = isExternal ? 
                `<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
                    <path d="M7.483 22.524 9.37 24.41l11.314-11.313v10.37h2.677V8.533H8.426v2.677h10.37L7.483 22.524Z"/>
                </svg>` :
                `<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                    <path d="M5.333 14.667v2.667h16L14 24.667l1.893 1.893L26.453 16 15.893 5.44 14 7.333l7.333 7.333h-16z"></path>
                </svg>`;
        }

        const iconWrapper = document.createElement('span');
        iconWrapper.classList.add('button-link-icon');
        iconWrapper.innerHTML = iconSvg;

        button.appendChild(iconWrapper);
    });
}

function setupSmoothScroll() {
    'use strict';
    
    // Only apply to pages or posts (check for common Ghost post/page elements)
    const isPostOrPage = document.querySelector('.post-content, .page-content, .ghost-content, article.post, article.page');
    if (!isPostOrPage) return;
    
    // Find all anchor links that start with #
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                e.preventDefault();
                
                // Calculate offset to account for fixed headers
                const headerOffset = 20; // Adjust this value based on your header height
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerOffset;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}

function setupScrollToTop() {
    'use strict';
    
    const scrollToTopButtons = document.querySelectorAll('.scroll-to-top');
    
    scrollToTopButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tocElement = document.getElementById('post-feed-toc');
            
            if (tocElement) {
                const headerOffset = 20;
                const elementPosition = tocElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerOffset * 2;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
    });
}

function handleVideoPlayback() {
    const options = {
        root: null,
        rootMargin: '2px',
        threshold: [0, 0.5, 1]  // We'll observe at 0%, 25%, and 100% visibility
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const video = entry.target;
            
            if (entry.intersectionRatio >= 0.5) {
                // Load the video only when it's about to be played
                if (video.preload === 'none') {
                    video.preload = 'auto';
                }
                if (video.paused) {
                    // Only play if the video has loaded
                    if (video.readyState >= 3) {
                        video.play().catch(error => console.error('Error playing video:', error));
                    } else {
                        video.addEventListener('canplay', () => {
                            video.play().catch(error => console.error('Error playing video:', error));
                        }, { once: true });
                    }
                }
            } else if (entry.intersectionRatio === 0) {
                // The video is completely out of the viewport
                if (!video.paused) {
                    video.pause();
                }
            } else if (entry.intersectionRatio < 0.5) {
                // The video is less than 25% in the viewport
                if (!video.paused) {
                    video.pause();
                }
            }
        });
    }, options);

    // Add loading handler for each video
    const videos = document.querySelectorAll('video.preload-video');
    videos.forEach(video => {
        observer.observe(video);
        
        // Add error handling
        video.addEventListener('error', (e) => {
            console.error('Video loading error:', e);
            video.style.display = 'none'; // Hide video on error, showing poster/background
        });
    });
}

pagination();

function initNavigation() {
    'use strict';
    const menuToggle = document.getElementById('menuToggle');
    const navOverlay = document.getElementById('navOverlay');

    if (!menuToggle || !navOverlay) return;

    menuToggle.addEventListener('click', function() {
        toggleNavigation();
    });

    // Close menu when clicking on navigation links
    const navLinks = document.querySelectorAll('.nav-menu a');
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            closeNavigation();
        });
    });

    // Close menu when pressing Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && navOverlay.classList.contains('active')) {
            closeNavigation();
        }
    });

    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
        if (navOverlay.classList.contains('active')) {
            // Check if click is outside the navigation menu and toggle button
            if (!navOverlay.contains(e.target) && !menuToggle.contains(e.target)) {
                closeNavigation();
            }
        }
    });
}

function toggleNavigation() {
    'use strict';
    const menuToggle = document.getElementById('menuToggle');
    const navOverlay = document.getElementById('navOverlay');

    if (!menuToggle || !navOverlay) return;

    menuToggle.classList.toggle('active');
    navOverlay.classList.toggle('active');

    // Prevent body scrolling when menu is open
    if (navOverlay.classList.contains('active')) {
        body.classList.add('nav-open');
        // Show carousel when nav opens
        const navCarousel = navOverlay.querySelector('[data-nav-carousel]');
        if (navCarousel) {
            navCarousel.style.display = 'block';
        }
        // Initialize carousels in the newly opened nav
        initCarousel3D();
    } else {
        body.classList.remove('nav-open');
    }
}

function closeNavigation() {
    'use strict';
    const menuToggle = document.getElementById('menuToggle');
    const navOverlay = document.getElementById('navOverlay');

    if (!menuToggle || !navOverlay) return;

    menuToggle.classList.remove('active');
    navOverlay.classList.remove('active');
    body.classList.remove('nav-open');
}

function initTOCCollisionDetection() {
    'use strict';

    const tocContainer = document.querySelector('.toc-container');
    const tocSidebar = document.querySelector('.toc-sidebar');
    if (!tocContainer || !tocSidebar) return;

    let isThrottled = false;
    let animationFrame;

    // Cache DOM elements for performance
    const conflictingElements = document.querySelectorAll('.kg-blockquote-alt, .kg-card.kg-width-wide, .kg-card.kg-width-full, .kg-image.kg-width-wide, .kg-image.kg-width-full');

    function checkTOCCollisions() {
        if (!tocContainer || isThrottled) return;

        isThrottled = true;

        if (animationFrame) {
            cancelAnimationFrame(animationFrame);
        }

        animationFrame = requestAnimationFrame(() => {
            const tocRect = tocSidebar.getBoundingClientRect();
            let hasCollision = false;

            // Check if TOC is visible and positioned correctly
            if (tocRect.width === 0 || tocRect.height === 0) {
                isThrottled = false;
                return;
            }

            // Check each potentially conflicting element
            for (let i = 0; i < conflictingElements.length; i++) {
                const element = conflictingElements[i];
                const elementRect = element.getBoundingClientRect();

                // Only check elements that are actually visible and have dimensions
                if (elementRect.width <= 0 || elementRect.height <= 0) {
                    continue;
                }

                // Add margin to avoid false positives - only hide if there's significant overlap
                const margin = 20;
                const isOverlapping = !(
                    elementRect.right < (tocRect.left + margin) ||
                    elementRect.left > (tocRect.right - margin) ||
                    elementRect.bottom < (tocRect.top + margin) ||
                    elementRect.top > (tocRect.bottom - margin)
                );

                if (isOverlapping) {
                    // Additional check: ensure the element is actually in the viewport
                    const isInViewport = elementRect.bottom > 0 && elementRect.top < window.innerHeight;
                    if (isInViewport) {
                        hasCollision = true;
                        console.log('TOC collision detected with:', element.className);
                        break;
                    }
                }
            }

            // Apply or remove fade effect
            if (hasCollision) {
                tocContainer.classList.add('toc-fade-out');
            } else {
                tocContainer.classList.remove('toc-fade-out');
            }

            isThrottled = false;
        });
    }

    // Throttled scroll listener
    function handleScroll() {
        if (!isThrottled) {
            checkTOCCollisions();
        }
    }

    // Initial check
    setTimeout(checkTOCCollisions, 100);

    // Add scroll listener with throttling
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Also check on resize in case layout changes
    window.addEventListener('resize', () => {
        setTimeout(checkTOCCollisions, 50);
    });

    // Check when images load (which might change layout)
    const images = document.querySelectorAll('img');
    images.forEach(img => {
        img.addEventListener('load', () => {
            setTimeout(checkTOCCollisions, 10);
        });
    });
}

function headerScrollBehavior() {
    'use strict';

    const header = document.getElementById('gh-head');
    if (!header) return;

    let lastScrollY = window.scrollY;
    let headerTranslateY = 0;
    let ticking = false;
    const topThreshold = 50;
    const headerHeight = header.offsetHeight + 40;

    function handleScroll() {
        // Don't apply scroll behavior when mobile menu is open
        if (document.body.classList.contains('is-head-open')) {
            return;
        }

        const currentScrollY = window.scrollY;
        const scrollDifference = currentScrollY - lastScrollY;

        // Always show header at the very top
        if (currentScrollY <= topThreshold) {
            headerTranslateY = 0;
            header.style.transform = 'translate(-50%, 0)';
            lastScrollY = currentScrollY;
            return;
        }

        // Update header position based on scroll direction
        headerTranslateY -= scrollDifference;

        // Clamp the value between -headerHeight and 0
        headerTranslateY = Math.max(-headerHeight, Math.min(0, headerTranslateY));

        // Apply transform - both layouts need translateX(-50%) for centering
        header.style.transform = `translate(-50%, ${headerTranslateY}px)`;

        lastScrollY = currentScrollY;
    }

    const onScroll = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    };

    // Initialize header as visible
    header.style.transform = 'translate(-50%, 0)';

    window.addEventListener('scroll', onScroll, { passive: true });

    // Reset header position when menu opens/closes
    const observer = new MutationObserver(() => {
        if (document.body.classList.contains('is-head-open')) {
            // Remove transform completely when menu is open
            header.style.transform = '';
            headerTranslateY = 0;
        } else {
            // Restore transform when menu closes
            header.style.transform = 'translate(-50%, 0)';
        }
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
    });
}